import { EnvironmentId } from '@/react/portainer/environments/types';
import { AuthorizationMap } from '@/react/portainer/users/RolesView/types';

import { type UserId } from './types/user-id';

export { type UserId };

export enum Role {
  Admin = 1,
  Standard,
  EdgeAdmin,
}

export const RoleNames: { [key in Role]: string } = {
  [Role.Admin]: 'administrator',
  [Role.Standard]: 'user',
  [Role.EdgeAdmin]: 'edge administrator',
};

export type EndpointAuthorizations = {
  [endpointId: EnvironmentId]: AuthorizationMap;
};

export type ThemeColor = 'dark' | 'light' | 'highcontrast' | 'auto';

export type User = {
  Id: UserId;
  Username: string;
  Role: Role;
  EndpointAuthorizations?: EndpointAuthorizations;
  PortainerAuthorizations: AuthorizationMap;
  UseCache: boolean;
  ThemeSettings: {
    color: ThemeColor;
    subtleUpgradeButton: boolean;
  };
};
